import '../../ProductSlider/scripts/view';

import { Event } from '../../FilterList/scripts/product-facets';
import './comparison-view';

( function( $ ) {
	'use strict';

	$( document ).ready( function() {

		const $productLists = $( '.product-list-container' );


		if ( $productLists.length === 0 ){
			return;
		}

		( function() {

			window.colibri.card_cache = window.colibri.card_cache || { 'ready': {}, 'loading': {}, 'failed': {}, 'last_clicked': null };

			/**
			 *
			 */
			function loadProducts( maybeLoad, onSuccess, onFailure ) {

				const toLoad = [];

				$(maybeLoad).each( (idx, pc ) => {
					if (
						window.colibri.card_cache['ready'][pc] ||
						window.colibri.card_cache['loading'][pc] ||
						window.colibri.card_cache['failed'][pc]
					){
						return true;
					}
					toLoad.push(pc);
					window.colibri.card_cache[ 'loading' ][pc] = true;
				});

				if ( !toLoad.length ) {
					return;
				}

				const states = Object.keys( window.colibri.index.facets.state_code ?? {} );

				jQuery.ajax( {
					url: window.location.protocol + '//' + window.location.host + '/?cg-ajax-content=partial-grid' + (states.length === 1 ? '&state='+states[0]: ''),
					dataType: 'html',
					type: 'POST',
					data: {
						product_codes: JSON.stringify( toLoad )
					}
				} ).done( r => {
					$(toLoad).each( (idx, pc ) => {
						delete ( window.colibri.card_cache[ 'loading' ][ pc ] );
						delete ( window.colibri.card_cache[ 'failed' ][ pc ] );
						window.colibri.card_cache[ 'ready' ][ pc ] = true;
					});
					if ( typeof onSuccess === 'function' ) onSuccess( r );
				} ).fail( r => {
					$(toLoad).each( (idx, pc ) => {
						delete ( window.colibri.card_cache[ 'loading' ][ pc ] );
						delete ( window.colibri.card_cache[ 'ready' ][ pc ] );
						window.colibri.card_cache[ 'failed' ][ pc ] = true;
					});
					if ( typeof onFailure === 'function' ) onFailure( r );
				} );
			}

			function maybeUpdateCards($productList){

				const toLoad = [];

				$productList.find( '.card--placeholder' ).each( ( cardIdx, place ) => {
					toLoad.push( place.getAttribute( 'data-product-code' ) );
				} );

				if ( 0 === toLoad ) {
					return;
				}
				loadProducts( toLoad, response => {

					const $response = $( response );

					$response.find( '.product-list-container' ).not( '.is-empty' ).each( ( index, cont ) => {
						const $cont = $( cont );
						// const hash = $cl.attr( 'data-block-hash' );
						// const $targetList = $productList.filter( '.product-list-container[data-block-hash="' + hash + '"]' );
						const $cards = $cont.find( '.card' );
						let cnt = 0;
						$cards.each( ( k, c ) => {
							$productList.find( '#' + c.getAttribute( 'id' ) ).replaceWith( $( c ) );
							cnt++;
						} );
						$productList.removeClass( '.is-empty' );
					} );

					$( window ).triggerHandler( 'ColibriEvent:INIT_ALL_ADD_TO_CARTS', [ $productList ] );
					$productList.closest('.listing-container').trigger( Event.UPDATE_TIMEZONES );
					$productList.closest('.listing-container').trigger( Event.REQUEST_REINDEX );
				}, r => {
					console.error( 'failure', r );
				} );

			}

			function toggleShowAll( $showAll, $productList ) {

				if ( $showAll.is( '.is-expanded' ) ) {
					$showAll.removeClass( 'is-expanded' );
				} else {
					$showAll.data( 'caption', $showAll.text() );
					$showAll.addClass( 'is-expanded' );
				}

				$showAll.text( $showAll.is( '.is-expanded' )
							  ? 'Show Less'
							  : $showAll.data( 'caption' ) );

				$productList.toggleClass( 'is-collapsed' );

				maybeUpdateCards($productList);
			}

			/**
			 * Update cards for a single $productList
			 */
			function updateProductList( data, $showAll, $productList ){
				let countMatches = 0;
				let countCards = 0;

				const { countFilters, matchingProductsSet } = data;

				/**
				 * iterate over all cards and (un)hide those that match the current criteria
				 */
				const itemsToLoad = new Set();

				$productList.find( '.card' ).each( ( idx, card ) => {
					/**
					 * normalize target (for List View vs Grid View)
					 */
					const $card = $( card );
					const id = + card.getAttribute( 'data-item-id' );
					const productCode = card.getAttribute( 'data-product-code' );

					const $target = $card.parent().is( '.grid-col' )
										 ? $card.parent()
										 : $card;

					countCards ++;

					if ( !matchingProductsSet.size ) {
						/**
						 * no matches -- hide all items
						 */
						$target.addClass( 'd-none' );
						return true;
					}

					if ( !countFilters || matchingProductsSet.has( id ) ) {
						/**
						 * no filters -- show all items
						 */
						countMatches ++;
						$target.removeClass( 'd-none' );

						// if ( $card.is('.card--placeholder') ) {
						// 	itemsToLoad.add( productCode );
						// }

						if ( countMatches <= 24 ) {
							$target.removeClass( 'hide-when-collapsed' );
						} else {
							$target.addClass( 'hide-when-collapsed' );
						}

						return true;
					}

					/**
					 * hide item
					 */
					$target.addClass( 'd-none' )
				} );

				/**
				 * Maybe (un)hide the entire course list
				 */
				if ( !countMatches ) {
					$productList.addClass( 'is-empty' );
				} else {
					$productList.removeClass( 'is-empty' );

					/**
					 * Update [Show All] button
					 */
					if ( countMatches >= 24 ) {
						$showAll.html(
							$showAll.is( '.is-expanded' )
							? 'Show Less'
							: ( 'Show All (' + countMatches + ')' )
						).show();
					} else {
						$showAll.hide();
					}
				}

				/**
				 * Update results counter
				 */
				const itemsLabel = ( countMatches % 10 === 1 )
										 ? 'item'
										 : 'items';

				const message = countMatches
									 ? 'Found <span>' + countMatches + '</span> ' + itemsLabel
									 : 'No items match the current filtering criteria.'

				$productList.find( '.count-results' ).html( message );

				maybeUpdateCards($productList);
			}

			$productLists.each( ( index, pl ) => {
				const $productList = $( pl );
				const $showAll   = $productList.find( '.js-show-all' ).first();

				/**
				 * Handle clicks on Show All button
				 */
				$showAll.on( 'click', e => toggleShowAll( $showAll, $productList ));

				$productList.bind( Event.LIST_UPDATE, ( event, data ) => {
					updateProductList( data, $showAll, $productList )
				})

			} );

		} )();

	} ); //ready

} )( jQuery );

